import { render, staticRenderFns } from "./builds.vue?vue&type=template&id=85eea4ec&scoped=true"
import script from "./builds.vue?vue&type=script&lang=js"
export * from "./builds.vue?vue&type=script&lang=js"
import style0 from "./builds.vue?vue&type=style&index=0&id=85eea4ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85eea4ec",
  null
  
)

export default component.exports